// Responsive image helpers for the two hosts we use (Unsplash + the existing PlumbSmart CDN).
const IRP = "https://irp.cdn-website.com/";

export function sized(src, w) {
  if (!src) return src;
  if (src.includes("images.unsplash.com")) return `${src}&w=${w}&auto=format`;
  if (src.startsWith(IRP)) {
    const clean = src.replace("/multi/opt/", "/multi/").replace(/-\d+w(\.\w+)$/, "$1");
    return clean.replace("/multi/", "/multi/opt/").replace(/(\.\w+)$/, `-${w}w$1`);
  }
  return src;
}

export function srcSet(src, widths = [480, 800, 1200, 1600]) {
  return widths.map((w) => `${sized(src, w)} ${w}w`).join(", ");
}

export const Img = ({ src, alt, widths, sizes = "100vw", className = "", eager = false, priority = false, width, height, ...rest }) => (
  <img
    src={sized(src, (widths || [800])[Math.min(1, (widths || [800]).length - 1)])}
    srcSet={srcSet(src, widths)}
    sizes={sizes}
    alt={alt}
    width={width}
    height={height}
    loading={eager ? "eager" : "lazy"}
    fetchpriority={priority ? "high" : undefined}
    decoding="async"
    className={className}
    {...rest}
  />
);
